import { useTranslation } from 'react-i18next'
import styles from './EmptyProjectTemplateTasksList.module.css'

const EmptyProjectTemplateTasksList = () => {
	const { t } = useTranslation()
	return <div className={styles.EmptyProjectTemplateTasksList}>{t('empty_subtasks_list')}</div>
}

export default EmptyProjectTemplateTasksList
